import { withDependencies } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import { SeoSiteSymbol } from 'feature-seo'
import type { ISeoSiteApi } from 'feature-seo'
import { SeoServiceDefinition as definition } from '@wix/seo-service/definition'
import { createSeoService as impl } from '@wix/seo-service/implementations'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import type { ISeoServiceDefinition } from '@wix/seo-service/definition'

export const SeoService: FactoryWithDependencies<ServiceProvider<ISeoServiceDefinition, typeof impl>> =
	withDependencies([SeoSiteSymbol], (seoSiteApi: ISeoSiteApi): ServiceProvider<ISeoServiceDefinition, typeof impl> => {
		return {
			definition,
			impl,
			config: {
				seoApi: {
					setVeloSeoTags: seoSiteApi.setVeloSeoTags,
					resetVeloSeoTags: seoSiteApi.resetVeloSeoTags,
				},
			},
		}
	})
